import Api from '@api'

export default class ClientOnboadringManagement extends Api {
  applicationList = params => {
    return this.get('/api/v1/private/groups/applications/')
  };

  recipientList = params => {
    return this.get(
      `/api/v1/private/groups/applications/${params.applicationId}/recipients/`
    )
  };

  batch = (options = {}, batchOperations) => {
    return this.post(
      `/api/v1/private/groups/applications/${options.applicationId}/batch`,
      batchOperations,
      options.params
    )
  };

  resendEmail = params => {
    return this.post(
      `/api/v1/private/groups/applications/${params.applicationId}/email/`
    )
  };
}
